import {Close, DeleteOutline} from '@mui/icons-material';
import {useDropzone} from 'react-dropzone';
import {Language} from '../../../context/LanguageContext';
import {
  AddCircleIcon,
  DigMapIcon1,
  IconDeleteRed,
  IconMapfileEmpty,
} from '../../../assets';
import {useCallback, useState} from 'react';
import {APIURL} from '../../../consts';
import axios from 'axios';
import Cookies from 'js-cookie';
import {LinearProgress} from '@mui/material';
export default function FormMapFile({data, onClose}) {
  const {newObj, language} = Language();
  const [openUpload, setOpenUpload] = useState(false);
  const [typeUpload, setTypeUpload] = useState('');
  const [progress, setProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('Start Upload');
  const [step, setStep] = useState(1);
  const [selectDelete, setSelectDelete] = useState(false);
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const tokens_session = Cookies.get('token');
  const handleDelete = async (type, pk_code, data) => {
    try {
      let url = ``;
      switch (type) {
        case 'raster':
          url = `${apiUrl}/mapping/delete-raster?pk_code=${pk_code}`;
          break;
        case 'dirian':
          url = `${apiUrl}/mapping/delete-dirian?pk_code=${pk_code}`;
          break;
        case 'map':
        default:
          url = `${apiUrl}/mapping/delete`;
          break;
      }

      if (type === 'raster' || type === 'dirian') {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${tokens_session}`,
            'Content-Type': 'application/json',
          },
        });
        if (response.status === 200) {
          onClose();
        }
      } else {
        const response = await axios.post(
          url,
          {
            nama_kawasan: data.namaKawasa,
            status: data.publish ? 'publish' : 'draft',
          },
          {
            headers: {
              Authorization: `Bearer ${tokens_session}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.status === 200) {
          onClose();
        }
      }
    } catch (error) {}
  };
  const handleOnDrop = useCallback(
    async (acceptedFiles, typeUpload) => {
      setStep(2);
      setProgress(0);
      let eventSource = new EventSource(
        typeUpload === 'raster'
          ? APIURL.map_upload_raster_progress
          : APIURL.map_upload_dirian_pokok_progress
      );
      let guidValue = '';
      eventSource.addEventListener('GUI_ID', async (event) => {
        guidValue = event.data.replace(/"/g, '') || '';
        eventSource.addEventListener(guidValue, (event) => {
          const result = JSON.parse(event.data);
          if (progress !== result.progress) {
            setProgress(result.progress);
          }
          if (uploadStatus !== result.status) {
            setUploadStatus(result.status);
          }
          if (result.status === 'Done!') {
            eventSource.close();
          }
        });
        const formData = new FormData();
        formData.append('file', acceptedFiles);
        formData.append('pkCode', data.selected.kodKawasa);
        formData.append('lang', language == 1 ? 'en' : 'my');
        formData.append('guid', guidValue);
        const response = await axios.post(
          typeUpload === 'raster'
            ? APIURL.map_upload_raster
            : APIURL.map_upload_dirian_pokok,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${Cookies.get('token')}`,
            },
          }
        );
        if (response.status === 200) {
          setStep(1);
          setProgress(0);
          const responseList = await data.selected.getList();
          const updatedData = responseList.find(
            (item) => item.kodKawasa === data.selected.kodKawasa
          );
          data.selected.setSelected(updatedData);
          setOpenUpload(false);
          setTypeUpload('');
          eventSource.close();
        } else {
          eventSource.close();
        }
      });

      eventSource.onerror = (event) => {
        if (event.target.readyState === EventSource.CLOSED) {
          console.log('SSE closed (' + event.target.readyState + ')');
        }
        setProgress(0);
        eventSource.close();
      };

      eventSource.onopen = () => {
        console.log('connection opened');
      };
    },
    [language]
  );
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        handleOnDrop(file, typeUpload);
      });
    },
    [typeUpload]
  );

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    accept: {
      'application/zip': ['.zip'],
    },
  });

  const renderDropzone = (step) => {
    switch (step) {
      case 2:
        return (
          <div className='mapfile_raster_upload'>
            <div className='box'></div>
            <div className='progress'>
              <p>{uploadStatus}</p>
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: '10px',
                  width: '100%',
                  marginTop: '10px',
                }}
              />
            </div>
          </div>
        );
      case 1:
      default:
        return (
          <div className='mapfile_raster_upload' {...getRootProps()}>
            <div className='box'></div>
            <input {...getInputProps()} />
            <p>Drop file here to start upload</p>
            <button>Select File</button>
          </div>
        );
    }
  };

  return (
    <div className='modal_content center mapfile'>
      <div className='modal_header mapfile'>
        <div className='mapfile_head'>
          <img src={DigMapIcon1} alt='' />
          <p className='modal_title'>{data.selected.namaKawasa}</p>
        </div>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className='modal_body '>
        <div className='mapfile_info'>
          <p className='mapfile_body_title'>Info</p>
          <div className='mapfile_info_item'>
            <p className='mapfile_info_label'>Nama Kawasan</p>
            <p className='mapfile_info_value'>{data.selected.namaKawasa}</p>
          </div>

          <div className='mapfile_info_item'>
            <p className='mapfile_info_label'>PK Code</p>
            <p className='mapfile_info_value'>{data.selected.namaKawasa}</p>
          </div>
          <div className='mapfile_info_item'>
            <p className='mapfile_info_label'>Total Project</p>
            <p className='mapfile_info_value'>
              {data.selected.totalProjek || 0}
            </p>
          </div>
        </div>
        <div className='mapfile_raster'>
          <>
            {selectDelete === 'map' ? (
              <div className='mapfile_raster_delete'>
                <p>Are you sure want to delete this map?</p>
                <div className='btn'>
                  <button
                    className='cancel_btn'
                    onClick={() => setSelectDelete('')}
                  >
                    Cancel
                  </button>
                  <button
                    className='delete_btn'
                    onClick={() =>
                      handleDelete(
                        'map',
                        data.selected.kodKawasa,
                        data.selected
                      )
                    }
                  >
                    Delete
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className='mapfile_raster_head'>
                  <p className='mapfile_body_title'>Uploaded Raster</p>
                  <div className='mapfile_raster_btn'>
                    <button
                      onClick={() => {
                        setOpenUpload((prev) => !prev);
                        setTypeUpload('raster');
                      }}
                    >
                      <img src={AddCircleIcon} alt='' /> Raster Map
                    </button>
                    <button
                      onClick={() => {
                        setOpenUpload((prev) => !prev);
                        setTypeUpload('dirian');
                      }}
                    >
                      <img src={AddCircleIcon} alt='' /> Dirian Pokok
                    </button>
                  </div>
                </div>
                {openUpload && renderDropzone(step)}
                {(data.selected?.dirianPokokKey ||
                  data.selected?.rasterKey) && (
                  <div className='mapfile_raster_body'>
                    {data.selected?.rasterKey && (
                      <div className='mapfile_raster_body_item'>
                        {selectDelete === 'raster' ? (
                          <>
                            Are you sure want to delete this file?
                            <div className='right'>
                              <button
                                className='cancel_btn'
                                onClick={() => setSelectDelete('')}
                              >
                                Cancel
                              </button>
                              <button
                                className='delete_btn'
                                onClick={() =>
                                  handleDelete(
                                    'raster',
                                    data.selected.kodKawasa
                                  )
                                }
                              >
                                Delete
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className='left'>
                              <img src='' alt='' />
                              {data.selected?.rasterKey}
                            </div>
                            <div
                              className='right'
                              onClick={() => setSelectDelete('raster')}
                            >
                              <img src={IconDeleteRed} alt='icon_delete_red' />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {data.selected?.dirianPokokKey && (
                      <div className='mapfile_raster_body_item'>
                        {selectDelete === 'dirian' ? (
                          <>
                            Are you sure want to delete this file?
                            <div className='right'>
                              <button
                                className='cancel_btn'
                                onClick={() => setSelectDelete('')}
                              >
                                Cancel
                              </button>
                              <button
                                className='delete_btn'
                                onClick={() =>
                                  handleDelete(
                                    'dirian',
                                    data.selected.kodKawasa
                                  )
                                }
                              >
                                Delete
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className='left'>
                              <img src='' alt='' />
                              {data.selected?.dirianPokokKey}
                            </div>
                            <div
                              className='right'
                              onClick={() => setSelectDelete('dirian')}
                            >
                              <img src={IconDeleteRed} alt='icon_delete_red' />
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {!data.selected?.rasterKey &&
                  !data.selected?.dirianPokokKey &&
                  !openUpload && (
                    <div className='mapfile_raster_body_empty'>
                      <img src={IconMapfileEmpty} alt='' />
                      <p>No Raster Image Uploaded</p>
                    </div>
                  )}
              </>
            )}
          </>
        </div>
        {selectDelete !== 'map' && (
          <div className='mapfile_btn'>
            <button
              className='btn delete'
              onClick={() => setSelectDelete('map')}
            >
              Delete
            </button>
            <button className='btn' onClick={() => onClose()}>
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
